import React from 'react';
import PropTypes from 'prop-types';
import { CircleNotch } from '@phosphor-icons/react';
import './style.scss';

const InlineLoader = ({ 
  size = 16, 
  color = '#FF2459', 
  className = '',
  text = '',
  showText = false
}) => {
  return (
    <div className={`inline-loader flex items-center gap-2 ${className}`}>
      <CircleNotch
        className="loader-icon animate-spin"
        size={size}
        color={color}
      />
      {showText && text && (
        <span className="loader-text text-sm text-gray-600">{text}</span>
      )}
    </div>
  );
};

InlineLoader.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  showText: PropTypes.bool,
};

export default InlineLoader;
